import Footer from "../../components/common/layout/Footer";
import { MarketingHero, WhyMarket, FAQ, FeatureSection, IncludedPlan, MarketingSection, PricingPlan } from "@/components/features/marketing";
import AnimatedSection from "../../components/common/animations/AnimatedSection";
import ParallaxSection from "../../components/common/animations/ParallaxSection";
import SEO from "@/components/common/seo/seo";

export default function Marketing() {

    return (
        <>
            <SEO
                title="Marketing that converts - SAN micron"
                description="Attract customers with breakthrough marketing content. Our expert team crafts compelling campaigns that drive engagement and boost your brand's presence."
            />
            <div className="relative overflow-hidden">
                <ParallaxSection speed={0.3}>
                    <MarketingHero />
                </ParallaxSection>

                <AnimatedSection delay={0.1} direction="up">
                    <PricingPlan />
                    <FeatureSection />
                </AnimatedSection>

                <ParallaxSection speed={0.25}>
                    <AnimatedSection delay={0.2} direction="up">
                        <IncludedPlan />
                    </AnimatedSection>
                </ParallaxSection>

                <AnimatedSection delay={0.3} direction="up">
                    {/* <AttractCustomers /> */}
                    {/* <WhatIsOMH /> */}
                    <MarketingSection />
                </AnimatedSection>


                <WhyMarket />

                <ParallaxSection speed={0.2}>
                    <AnimatedSection delay={0.4}>
                        <FAQ />
                    </AnimatedSection>
                </ParallaxSection>

                <AnimatedSection delay={0.5}>
                    <Footer />
                </AnimatedSection>
            </div>
        </>
    );
}